// The tenant id is not exposed by the API yet (no /me endpoint). Once it is, prefix every key with it
// here so the cache stays tenant-namespaced (frontend architecture §4).
export const queryKeys = {
  health: ["health"] as const,
  gpsHealth: ["integrations", "gps", "health"] as const,
  identityProviders: ["auth", "idp"] as const,
  auditEvents: (filters: { action: string; targetType: string }) => ["admin", "audit", filters] as const,
  syncRun: (runId: string) => ["gps", "asset-sync", "run", runId] as const,
  syncObservations: (runId: string) => ["gps", "asset-sync", "observations", runId] as const,
  syncPreview: ["gps", "asset-sync", "preview"] as const,
  syncAudit: (target: string) => ["gps", "asset-sync", "audit", target] as const,
  history: (resource: string, vehicleId: string, from: number, until: number) =>
    ["telemetry", "history", resource, vehicleId, from, until] as const,
  syncControl: (vehicleId: string) => ["telemetry", "sync-control", vehicleId] as const,
  commands: ["devices", "commands"] as const,
  commandList: (status: string) => ["devices", "commands", "list", status] as const,
  command: (commandId: string) => ["devices", "commands", "detail", commandId] as const,
  maintenance: ["maintenance"] as const,
  maintenanceTasks: ["maintenance", "tasks"] as const,
  maintenancePrograms: ["maintenance", "programs"] as const,
  maintenanceProgramTasks: (programId: string) => ["maintenance", "programs", "tasks", programId] as const,
  maintenanceSchedules: (state: string, vehicleId: string) => ["maintenance", "schedules", state, vehicleId] as const,
  maintenanceStatus: (scheduleId: string) => ["maintenance", "schedules", "status", scheduleId] as const,
  maintenanceBaseline: (scheduleId: string) => ["maintenance", "schedules", "baseline", scheduleId] as const,
  maintenanceWorkOrders: (status: string, vehicleId: string) => ["maintenance", "work-orders", "list", status, vehicleId] as const,
  maintenanceWorkOrder: (orderId: string) => ["maintenance", "work-orders", "detail", orderId] as const,
  maintenanceWorkshops: ["maintenance", "workshops"] as const,
  trackingSnapshot: ["fleet", "tracking", "snapshot"] as const,
  vehicleTracking: (vehicleId: string) => ["fleet", "tracking", "vehicle", vehicleId] as const,
};
